module.exports = __webpack_public_path__ + "img/objective-stuck.2d230087.png";